export const navegationConstants = {
  NAVIGATION_ALL: "NAVIGATION_ALL"
};
